//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../../constant/Endpoint";
import useGetHook from "../../../customHooks/useGetHook";
import usePostHook from "../../../customHooks/usePostHook";
import CrossIcon from "../../../Icons/CrossIcon";
import Button from "../../Reusable/Button";
import RecursiveComment from "./RecursiveComment";

const Reply = ({
  selectedRow,
  canInput = true,
}: {
  selectedRow?: any;
  receiver?: string;
  canInput: boolean;
}) => {
  const selectedOrder = selectedRow?.original?.id;
  const { refetchQueries } = useQueryClient();
  const [comment, setComment] = useState<any>();
  const { data: profile } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { data: remarks } = useGetHook({
    queryKey: [`remakrs-${selectedOrder}`],
    url: APIS.COMMENT,
    params: {
      limit: 200,
      offset: 0,
      object_id: selectedOrder,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`remakrs-${selectedOrder}`],
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm<any>({
    // resolver: yupResolver(orderRemarksValidationForm),
  });

  const handleCreateReview = async (data: any, id: any) => {
    const url = `${APIS.COMMENT}`;
    let formData = {
      ...data,
      branch: profile?.default_branch?.id,
      parent: id,
      object_id: selectedOrder,
    };
    try {
      await mutateAsync({ url, formData, setError });
      reset();
      setComment(null);
      refetchQueries();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <section className={tw`bg-white  mt-4`}>
        <div className={tw`mx-auto px-4`}>
          <h2 className={tw`text-center`}>
            <span className={tw`uppercase`}>
              {selectedRow?.original?.title}
            </span>
            <br />
            <span>Conclusion:</span>
            <span className={tw`capitalize`}>
              {selectedRow?.original?.resolution}
            </span>
          </h2>
          <div className={tw`max-h-[50svh] overflow-y-auto`}>
            {remarks?.results?.map((item, index) => (
              <RecursiveComment
                key={item?.id}
                item={item}
                setComment={setComment}
              />
            ))}
          </div>
          {canInput && (
            <div className={tw`mt-4 `}>
              <form className={tw`mb-6`}>
                {comment && (
                  <div className={tw`my-1 py-2 border-t-[1px]`}>
                    <div className="flex justify-between w-full items-center">
                      <p className={tw`text-sm text-[#787878]`}>
                        Replying to {comment?.user?.name}
                      </p>
                      <button
                        className={tw`cursor-pointer focus:outline-none`}
                        onClick={() => setComment("")}
                      >
                        <CrossIcon />
                      </button>
                    </div>

                    <p className={tw`text-gray-500 ml-2`}>{comment?.comment}</p>
                  </div>
                )}
                <div
                  className={tw`py-2 px-4 mb-4 bg-white rounded-lg rounded-t-lg border border-gray-200 `}
                >
                  <textarea
                    id="comment"
                    rows={6}
                    {...register("comment")}
                    className={tw`px-0 w-full text-sm bg-white text-gray-900 border-0 focus:ring-0 focus:outline-none `}
                    placeholder="Write a comment..."
                    required
                  ></textarea>
                </div>
                <div className={tw`flex justify-end w-full`}>
                  <div className={tw`w-[100px] mr-4`}>
                    <Button
                      label={"Create"}
                      isLoading={isPostLoading}
                      onClick={handleSubmit((data: any) =>
                        handleCreateReview(data, comment?.id)
                      )}
                    />
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Reply;
